import Dashbaord from '../../features/trainer/Dashbaord'
const TrainerDashbaordPage = () => {
  return <Dashbaord/>
}

export default TrainerDashbaordPage